import { createCollectionReducer } from 'reducers/account/collections';
import { TYPE } from './constants';

export default createCollectionReducer(TYPE);

export const selectProfileAttributeLabels = state => state.account[TYPE];
